function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M305.87,428.25H292.13v-1h13.74a1.3,1.3,0,0,0,1.3-1.3v-8.8a1.3,1.3,0,0,0-1.3-1.3H292.13a1.3,1.3,0,0,0-1.3,1.3v8.64h-1v-8.64a2.3,2.3,0,0,1,2.3-2.3h13.74a2.3,2.3,0,0,1,2.3,2.3V426A2.3,2.3,0,0,1,305.87,428.25Z",
  transform: "translate(-287.83 -412.86)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M297.2,428.25h-7.08a2.3,2.3,0,0,1-2.3-2.3v-10.8a2.3,2.3,0,0,1,2.3-2.3h7.08a2.3,2.3,0,0,1,2.3,2.3h-1a1.3,1.3,0,0,0-1.3-1.3h-7.08a1.3,1.3,0,0,0-1.3,1.3V426a1.3,1.3,0,0,0,1.3,1.3h7.08Z",
  transform: "translate(-287.83 -412.86)"
});

var SvgFilesListingFolder = function SvgFilesListingFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#444445",
    width: "20px",
    height: "15px",
    "data-name": "Layer 1",
    viewBox: "0 0 20.33 15.39",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilesListingFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/files_listing_folder.6ff69892.svg";
export { ForwardRef as ReactComponent };